import { Box, IconButton, Typography } from '@mui/material';
import { MdOutlineEdit } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';
import Button from 'components/Common/Button';
import Input from 'components/Common/Input';
import NotesIcon from 'assets/icons/NotesIcon';
import type { Control, UseFormHandleSubmit } from 'react-hook-form';

type Note = {
  id: number;
  description: string;
  created_at: string;
};

interface FormValues {
  contact: { call: number | string; [key: string]: unknown };
  note: { description: string };
}

export default function NotesPanel({
  notes,
  formatNoteDate,
  control,
  handleSubmit,
  editingNote,
  onEditClick,
  onDelete,
  onSubmit,
  isPending
}: {
  notes?: { data: Note[] };
  formatNoteDate: (date: string) => string;
  control: Control<FormValues>;
  handleSubmit: UseFormHandleSubmit<FormValues>;
  editingNote: number | null;
  onEditClick: (note: { id: number; description: string }) => void;
  onDelete: (id: number) => void;
  onSubmit: (data: { note: { description: string } }) => Promise<void>;
  isPending: boolean;
}) {
  return (
    <>
      <Typography fontWeight={600} mb={1}>
        Notes
      </Typography>

      {notes?.data?.map((note) => (
        <Box
          key={note.id}
          sx={{
            p: '10px 14px',
            borderRadius: '8px',
            background: '#F8F9FA',
            display: 'flex',
            justifyContent: 'space-between',
            my: 1
          }}
        >
          <Box display='flex' gap={1} flex={1} alignItems='flex-start'>
            <NotesIcon />
            <Box minWidth={0}>
              <Typography variant='body2' sx={{ wordBreak: 'break-word' }}>
                {note.description}
              </Typography>
              <Typography fontSize='12px' color='secondary'>
                {formatNoteDate(note.created_at)}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ flexShrink: 0 }}>
            <IconButton onClick={() => onEditClick(note)}>
              <MdOutlineEdit size={20} color='#09090A' />
            </IconButton>
            <IconButton onClick={() => onDelete(note.id)}>
              <RiDeleteBin6Line size={20} color='#09090A' />
            </IconButton>
          </Box>
        </Box>
      ))}

      <Box component='form' onSubmit={handleSubmit(onSubmit)}>
        <Box mt={2}>
          <Input multiline minRows={3} name='note.description' placeholder='Add a note' fullWidth control={control} />
        </Box>
        <Button type='submit' fullWidth sx={{ mt: 2 }} isPending={isPending}>
          {editingNote ? 'Update Note' : 'Add Note'}
        </Button>
      </Box>
    </>
  );
}
